import { contributions } from "../data/portfolio";
import "../styles/Portfolio.css";

const OpenSourceSection = () => {
  return (
    <section id="opensource" className="portfolio-section">
      <div className="portfolio-container">
        <h2 className="section-label">Open Source</h2>
        <div className="card-grid">
          {contributions.map((contribution, index) => (
            <a
              key={index}
              href={contribution.repoUrl || contribution.prUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="card opensource-card"
            >
              <h3 className="card-title">{contribution.repo}</h3>
              <p className="card-subtitle">{contribution.description}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OpenSourceSection;
